module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_28",
      "title": "28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub_ePub-Script"
  }, [_vm._v("Chapter Three")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Freddie and I ran out onto the lawn to see Antonia crouched by Joey lying tangled up in a bed of ferns.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Joey! Are you okay?” I yelled as Freddie and I ran over, Stanley clutched in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m fine. I’m fine,” Joey said, holding up a hand. “Hey guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What were you doing up there?” Freddie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I just wanted to get that weather vane up,” Joey said, pointing to a giant rusted steel chicken that had impaled itself with its north arrow deep into the earth. It was still vibrating from the impact.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You could have died,” Antonia said, voice catching.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He ruffled her hair. “Nah, don’t you worry. Take more than that to get rid of me, kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Silver bullet,” I whispered, elbowing Freddie in the ribs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He didn’t react.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You know, because you’re always saying that Joey "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_29",
      "title": "29"
    }
  }, [_vm._v("looks like a werewolf … and silver bullets kill werewolves?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“A woman has died, Erica.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("My jaw dropped. Did he just … "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("dead shame")]), _vm._v(" me? Now I "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("knew")]), _vm._v(" something was wrong. We were each other’s safe places. If Freddie and I couldn’t even make inside werewolf jokes at the most inappropriate times … well, I didn’t know who we were.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Joey untangled himself from the foliage and hauled himself to his feet. “Thanks for coming,” he said to Freddie and me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No problem, but are you sure you’re okay?” I asked, looking him over.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Maybe we should take you to the hospital,” Antonia said. “Get you checked out.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m fine. Really,” Joey said, making eye contact with all of us in turn. “It’s Candace we need to be worried about. I … I don’t know what to do to make this better.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t worry. We’re here to help,” Freddie said. “What do you guys like on your pizza?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Joey and Antonia both shot him a look of confusion.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Maybe later,” Freddie said quickly. “So where’s Candace at?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Joey looked back at the cottage. “Inside. She’s really upset. I mean … of course she’s upset.” He shook his head and climbed the steps to the front door. “This was not how this day was supposed to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Are her parents here?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Joey stiffened. “I think maybe I should let Candace tell you about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Antonia followed him. As she passed me, I could "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_30",
      "title": "30"
    }
  }, [_vm._v("have sworn I heard her mutter, “She didn’t even come outside to see what happened.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Joey shot her a warning look before opening the door for us to step inside. “Have you guys met my sister, Toni?” he said, waving a hand at the young woman who had also pushed past him and dropped onto the couch. She looked like she was about to angry-cry again.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We haven’t actually spoken,” I said. “It’s nice to meet you. Too bad about the … circumstances.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She tried to give me an acknowledging smile. I think. It was hard to tell. It could have been a “I hate this town and everybody in it” smile too.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ll, uh, take you to Candace,” Joey said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Wait,” Antonia snapped, popping up. “Where’s Nonna?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Joey stiffened again and looked around the room.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Nonna?” I asked, looking too. “She’s here?” I don’t know where I thought she would be. Still at the bar maybe?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She wanders,” Joey said quickly. “She was sitting in here when we went outsi—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“There she is,” Antonia said, pointing out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I looked and there was the same woman I had seen last night shuffling across the back lawn … waving an umbrella at a squirrel? In fairness, the squirrel looked like a jerk. It was standing on its hind legs chittering pretty loudly—just out of the umbrella’s reach.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She’s a really sweet woman,” Joey said, as she made another swipe for the squirrel. “She’s just got a thing about tree rats.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Tree rats?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_31",
      "title": "31"
    }
  }, [_vm._v("“It’s what she calls them. I’d better—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Candace is in the bedroom?” I asked. We’d been over enough to know the way.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You go ahead. We’ll just…” I pointed to the back.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Candace’s rental cottage was decorated to match her personality perfectly. There was lots of yellow and sky blue everywhere and it had a sunflower motif carried room to room. It also smelled vaguely of cupcakes. Candace liked to bake—which was probably some of the reason why we liked to visit so much. Well, that, and, you know, Candace was a really nice person.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I knocked lightly at the bedroom door before peeking my head in. “Candace?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Oh boy. I had seen Candace cry before. New Year’s. It was a big, messy, ugly drunken cry. I was kind of expecting the same thing today, but this was much, much worse. There she was sitting up in bed looking kind of like a bunny … whose puppy just got run over by a truck. If that made any sense. Probably not. But she was both adorable and sad. Killer combination. She wasn’t crying at the moment, but was right on the cusp of that tear-filled eyes and trembling-lip cry. She had her curly blond hair piled up in a messy bun on the top of her head and was wearing flannel pajamas. Her nose and eyes were bright, bright red. I gathered she hadn’t heard us come in—or heard Joey tumble off the roof—because of the earphones she was wearing, but she spotted me now.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The sight of Candace had me tempted to call my mother. This type of situation was right in her comfort zone. I could see it now. She would probably rush right over to the bed, pull Candace onto her lap, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_32",
      "title": "32"
    }
  }, [_vm._v("rock her like a baby while smoothing back her hair. That’s what Candace looked like she needed. I just wasn’t made that way. I think my mother rocked it all out of me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I sat on the edge of the bed and patted her shin through the quilt she had over her. “Candace? Freddie and I are here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She’s sad, not blind from a fever,” Freddie snapped before tagging on a, “Hey.” He then put Stanley on her bed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Thanks for coming, guys,” she said. “You didn’t have to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Of course we did. How are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She shook her head and fresh tears rolled down her cheeks. “I just don’t understand any of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I grabbed a tissue from the nightstand and started dabbing her face before I realized it was probably best to just let her do it. She was blinking like I had poked her in the eye. “Do you know what happened? To Lyssa, I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Not really. It doesn’t make any sense. Amos came by from the sheriff’s department this morning.” Candace looked at me with teary confused eyes. “They think that maybe she went swimming. She had had a lot to drink. She may have gone out too far and…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I didn’t know what to say. I looked to Freddie for help, but he was scrutinizing a kitten figurine he had picked up from Candace’s dresser.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s my fault. I rented them a place on the water,” she went on. “I lost track of her for a bit, so I texted her. She said they were headed there. I should have made sure. I just thought…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I patted her leg again. “It’s not your fault.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_33",
      "title": "33"
    }
  }, [_vm._v("Freddie didn’t look over but he asked, “Who’s ‘them’?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sorry?” Candace asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You said you rented "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("them")]), _vm._v(" a place. Who’s them?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lyssa and her boyfriend, Justin. When she got here, she said they had broken up.” Her face twitched all over with the effort of trying to hold back fresh tears. “She really likes … liked him, but thought maybe he was too young. Apparently he just showed up in town during the party and texted her. She said she needed to talk to him. She threw her hands in the air. “I don’t know where he is now. Where he lives. Anything.” She shook her head. “I need to tell him, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m sure the sheriff’s department is looking for him. Don’t worry about that right now.” I patted her leg some more. Just in a slightly different spot. I didn’t want to leave a bruise.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Are they sure what happened to Lyssa was accidental?” Freddie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What … else could it have been?” A look of horror spread across Candace’s face. “You don’t mean—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Nice work, sport,” I hissed at Freddie before turning back to Candace. “No, he doesn’t mean anything. Ignore him.” Thankfully, Freddie was back to ignoring us too. He was flipping through a binder of some sort on Candace’s dresser. A big white binder. I mean, I kind of wanted an answer to that question too, but I knew better than to just ask it. Besides, given our history, Freddie and I always had murder on the brain. But this had to have been be an accident. The alternative was just too grim.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Lyssa was just so full of life. To think that maybe someone …")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_34",
      "title": "34"
    }
  }, [_vm._v("No. Just … no.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“They were able to identify her with all the pictures from the party last night, so I don’t have to”—Candace swallowed hard—“see her. She doesn’t have any family really.” She pressed the tissue to her eyes. “I should have gone to find her. And why would she go swimming?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t know,” I said, shaking my head. But I could find out. Or at least try. “If you want, Freddie and I could go over to the sheriff’s department and—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Freddie cleared his throat, but I ignored him. A new thought had suddenly occurred to me. “Wait, you said earlier that Amos came by? You mean, Grady didn’t come himself?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She shook her head. “I wish he had. I mean I know with our history…” Again, Grady and Candace had dated during one of Grady’s and my "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("off")]), _vm._v(" periods—a nine-month period—which was longer than all of our "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("on")]), _vm._v(" periods put together, but that was all ancient history. “Amos is just so sweet, but I tried to ask him some questions and … well, I’d like to hear Grady’s take, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Freddie and I exchanged looks. We did know. That was weird. Sheriffs of small towns were usually raised better than to not show up personally when someone has died.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What about the wedding?” Freddie suddenly asked. “Where does everything stand?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Candace’s hands flopped from her lap onto the bed. “I don’t even know where to start. Obviously, we can’t get married today. Joey’s already called the guests. But there’s so much more to do. And every time I try to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_35",
      "title": "35"
    }
  }, [_vm._v("start, I just think about Lyssa and…” Her breath hitched.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You two were pretty close, huh?” I said gently.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Candace sniffled back something and looked up at me with red-rimmed eyes. “I feel horrible for saying this, but no … I mean, not exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I just assumed because she’s your—was your maid of honor that—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She just called me out of the blue not too long ago wanting to visit. We got talking about the wedding and she just kind of took over just like she always used to do back when we were roommates in college. It didn’t seem like a bad idea. I didn’t really have anyone else I felt comfortable asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Oh,” I said with a nod. I was willing to bet the expression on my face was the resting nauseous one Freddie and Rhonda had been talking about at the party.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And now she’s dead.” She didn’t say it was her fault, but the look in her eye told me it was what she believed. This was bad. Not only was Candace’s big day ruined, but she blamed herself for Lyssa’s tragic death. We were going to need reinforcements.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Do you want us to get your parents? Are they staying in town?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“They were supposed to fly in today.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Today?” I couldn’t keep the surprise from my voice. “That’s cutting it close.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“They’re not exactly fans of…” She picked at the quilt covering her lap. “I called to tell them about Lyssa, and … then that whole conversation just turned into a big fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_36",
      "title": "36"
    }
  }, [_vm._v("“What? Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The same reason Joey’s sister thinks we shouldn’t get married.” After walking around the bed a bit, Stanley dropped himself by Candace’s hip. She gave his head a scratch. “It’s too soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I bet the ex-con bit doesn’t help either,” Freddie said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I looked over at him again. He was very lucky he was just out of striking distance.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“They want me to postpone the wedding by a couple of months, but they know I can’t do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Joey’s nonna,” Candace said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The woman taking on that squirrel out back?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Candace forced a smile. “It’s the only thing Joey really wanted for the wedding. For his grandmother to be there, remembering who he is. She has dementia and heart problems, so she’s leaving to live with Joey’s aunt in Italy. We don’t know how much time she has left. I don’t know, maybe we’ll just have to do a courthouse wedding—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Freddie gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I know,” Candace said, bursting into tears. “It’s awful, isn’t it? But I don’t know what other choice we have.” Oh boy, she was really sobbing now.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Please,” Freddie said. “Please don’t do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m sorry,” Candace said, waving her tissue in the air. “I’m so sorry. I don’t mean to cry like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s okay.” I suddenly found myself patting Candace all over. Legs, arms, shoulders, head … like I could pat her back together again. What was Joey thinking, inviting Freddie and me over? We were both really terrible at giving sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_37",
      "title": "37"
    }
  }, [_vm._v("“But you know,” Candace said in the unnaturally high squeaky voice. “This isn’t about me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You’re the bride. Everything is about you,” Freddie muttered and went back to flipping through the binder. Suddenly, I felt alarm bells go off deep in my consciousness, but I didn’t quite know why—")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s about poor Lyssa. How could I even think about getting married? And Joey and I have had such a fairy-tale relationship. We have been so blessed. I have so much to be thankful—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You have no idea how much you’re going to be thankful for,” Freddie further muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Both Candace and I gave Freddie strange looks that time, but he was still absorbed in the binder.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Really,” Candace, said, dragging her eyes away from Freddie. “It’s times like these that you need to count your blessings. The only tears shed today should be for Lyssa, not for my wedding.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Right you are,” Freddie said, snapping the binder shut.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Um, sorry?” I asked. “I think it’s okay if Candace feels a little sorry for herself.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Not anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What are you talking about, Freddie?” Candace asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m saying you don’t have to cry about the wedding anymore,” Freddie said. “It will be fabulous. Erica and I will take care of the whole thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We … will?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We’ve got everything we need right here,” he said, tapping the front cover. “It will be magical and beautiful and romantic and all that other crap. How does a month from now sound?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_38",
      "title": "38"
    }
  }, [_vm._v("“Oh Freddie, you are so sweet,” Candace said, crying even harder at his generosity. “But I couldn’t ask you to do that. Besides, Nonna’s leaving in just over two weeks, and I’m not sure I can even think about the wedding right now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You don’t have to think about the wedding. Didn’t I just say that?” Freddie asked me of all people. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I didn’t know!")]), _vm._v(" I was busy reeling. “Two weeks, that’s not much time. But doable. I assume you already have your own glass slippers?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("What … what was happening here? I was pretty sure he knew nothing about planning a wedding. Or replanning … or rescheduling … whatever! In fact, when Candace announced she was getting married a couple of months ago, Freddie had gone on about the fact that she’d better not ask him to plan it. That it was such a gay-man stereotype—I inwardly gasped. Of course! He was just covering for the fact that he’d really wanted to plan the wedding all along! It made perfect sense. Freddie loved telling people what to do and dressing up. He was a wedding planner at heart. He probably wanted to do the bachelorette party too! That’s why he hated it so much. He probably planned this whole th— Okay, that was going too far. I didn’t think he orchestrated Lyssa’s death. I was getting carried away. “Freddie,” I hissed, jumping to my feet, “what are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Erica’s right, Freddie. You are such a sweetheart,” Candace went on, “but there’s too much involved. It can’t be done.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Freddie’s eyes widened. “Can’t be done?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Oh God, by making it a challenge, she was just making it worse. “Excuse us for just a second,” I said "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_39",
      "title": "39"
    }
  }, [_vm._v("back to Candace with what I hoped was a reassuring smile then straight-armed Freddie to the other side of the room. “What exactly do you think you are doing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s not a big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Freddie, weddings are a big deal. A very big deal. Especially to people like Candace who started their wedding binders back in high school,” I said through my teeth. God, the binder was huge. I don’t think I put that much effort into, well, anything. I once started a vision board, but I couldn’t decide on the color of background I wanted, and it all just fell apart from there. “You don’t know anything about planning a wedding. I certainly don’t know anything about planning a wedding.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Listen. I know you have issues with weddings—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I do not have issues with weddings!” I shout-whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“But it’s just a party,” Freddie said. “A party she was planning to have at the town gazebo. Her vendors are mainly local. We can get them to postpone. The hard work is already done. It’ll be a piece of cake.” A smile touched the corner of his mouth. “Wedding cake. Get it?” Oh sure, now he was in a better mood.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I scowled at him. “This is the most important day of Candace’s life. We cannot screw it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Of course we’re not going to screw it up. That’s why we’re doing this, because what "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("will")]), _vm._v(" screw it up is a dead nonna attending the ceremony.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I … I don’t think that would happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You know what I mean. Besides,” he said under his breath, “someone in this cursed town should be happy and in love.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("What the heck was that supposed to mean?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_40",
      "title": "40"
    }
  }, [_vm._v("“And look at her,” Freddie hissed, waving a hand at Candace. “Does she look happy and in love to you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Candace sniffed. “Guys, you are so sweet, but…” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And")]), _vm._v(" she was crying again.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She needs us, Erica.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Really,” Candace called out through her tears, “I couldn’t ask you to do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("This was not happening.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("This couldn’t be happening.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("How was this happening?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I swallowed hard and faced Candace. “You’re not asking,” I said, forcing what I hoped was a convincing smile to my face. “We’re offering.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Oh Erica…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Nope,” Freddie said, holding his stop hand up. “No more crying. You’re going to need to pace yourself with all those tears. Save some for the wedding of your dreams.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“But … what about Lyssa?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lycra—I mean Lyssa—would want you to be happy,” Freddie said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“But I don’t think I could … I mean, until I know what happened…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No problem. It’s like Erica said. We’ll do that too. Pro bono,” he said, shooting me a look.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I struggled to keep my face neutral. Offering our services to look into Lyssa’s death was so not the same thing as offering our services to take over the wedding. We were way better at handling death than we were at handling love.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Do you really think it’s possible?” Candace asked. “Erica?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I looked back and forth between Freddie’s unread"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_41",
      "title": "41"
    }
  }, [_vm._v("able face and Candace’s devastated one now with just a little bit of hope.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I … uh … guess we can.” I said, making extra sure I was nodding my head up and down and not shaking it side to side. “Yup. We’ll do it. Will plan the wedding and find out what happened to Lyssa. No problem.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 72
// module chunks = 0